import React, { Component, Fragment } from "react";
import moment from "moment";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import shortid from "shortid";
import _ from "lodash";
import {
  Divider,
  Drawer,
  Row,
  Col,
  Form,
  Select,
  DatePicker,
  Button,
  Switch,
} from "antd";
import { dateToEnglish, formatDate } from "../../../../helpers/functions";
import { createLoadingSelector } from "../../../../store/api/selectors";
import { getProducts as getIcms } from "../Icms/actions";
import { getProducts as getPisCofins } from "../PisCofins/actions";
import { considerRevenue } from "../actions";
import {
  classifyProduct,
  deletePeriodClassify,
  getPeriodClassify,
} from "./actions";

const Option = Select.Option;

const classifyOptions = [
  { id: shortid.generate(), value: 1, text: "ICMS ST" },
  { id: shortid.generate(), value: 2, text: "ICMS PRÓPRIO" },
  {
    id: shortid.generate(),
    value: 3,
    text: "ANTECIPAÇÃO COM ENCERRAMENTO DE TRIBUTAÇÃO DE ICMS",
  },
];

class DrawerClassify extends Component {
  state = {
    isOk: true,
    dataSource: {
      Classificacao: {
        0: {
          Status: 0,
          DataInicio: null,
          DataFim: null,
          Error: [],
        },
      },
    },
    isRevenue: true,
    rangeDate: [],
    alertMessages: [],
  };

  componentDidMount() {
    const {
      isRevenue,
      listPeriod,
      selectedAll,
      selectedRowKeys,
      products,
    } = this.props;

    if (listPeriod.length) {
      this.setState({
        dataSource: {
          IdProduto: selectedRowKeys,
          Classificacao: { ...this.dateFormatSort(listPeriod) },
        },
      });
    } else {
      if (!selectedAll) {
        this.setState((prevState) => ({
          dataSource: {
            ...prevState.dataSource,
            IdProduto: selectedRowKeys,
          },
        }));
      }
    }
    if (selectedRowKeys.length === products.length || selectedAll) {
      this.setState({ isRevenue: true });
    } else {
      this.setState({ isRevenue });
    }
  }

  dateFormatSort(data) {
    let newData = _.sortBy(data, "DataInicio");
    newData = newData.map((item) => {
      return {
        Id: item.Id,
        Status: item.Classificacao ? item.Classificacao : item.Status,
        DataInicio:
          item.DataInicio && item.DataInicio !== "0001-01-01T00:00:00"
            ? moment(item.DataInicio).format("L")
            : null,
        DataFim: item.DataFim ? moment(item.DataFim).format("L") : null,
        Error: [],
      };
    });
    return newData;
  }

  validateClassify = (data) => {
    let rangeString, rangeDate, temp;

    this.setState({ isOk: true });

    data.map(async (item, index) => {
      temp = [...data];
      temp = temp.splice(0, index);
      rangeDate = await this.findMinMax(temp);
      rangeString = rangeDate.length
        ? [moment(rangeDate[0]).format("L"), moment(rangeDate[1]).format("L")]
        : [];

      if (!item.Status) {
        this.setState((state) => ({
          isOk: false,
          dataSource: {
            ...state.dataSource,
            Classificacao: {
              ...state.dataSource.Classificacao,
              [index]: {
                ...state.dataSource.Classificacao[index],
                Error: [
                  ...state.dataSource.Classificacao[index].Error,
                  "O campo classificação não pode ser vazio",
                ],
              },
            },
          },
        }));
      }
      if (moment(item.DataInicio).isAfter(item.DataFim)) {
        this.setState((state) => ({
          isOk: false,
          dataSource: {
            ...state.dataSource,
            Classificacao: {
              ...state.dataSource.Classificacao,
              [index]: {
                ...state.dataSource.Classificacao[index],
                Error: [
                  ...state.dataSource.Classificacao[index].Error,
                  "A data inicial não pode ser posterior a data final",
                ],
              },
            },
          },
        }));
      }
      if (
        moment(!item.DataInicio ? "02-01-0001" : item.DataInicio).isBetween(
          rangeDate[0],
          rangeDate[1]
        )
      ) {
        if (rangeDate[0] === "0001-01-01" && rangeDate[1] === "2100-12-31") {
          this.setState((state) => ({
            isOk: false,
            dataSource: {
              ...state.dataSource,
              Classificacao: {
                ...state.dataSource.Classificacao,
                [index]: {
                  ...state.dataSource.Classificacao[index],
                  Error: [
                    ...state.dataSource.Classificacao[index].Error,
                    "Período inválido",
                  ],
                },
              },
            },
          }));
        } else if (
          rangeDate[0] === "0001-01-01" &&
          rangeDate[1] !== "2100-12-31"
        ) {
          this.setState((state) => ({
            isOk: false,
            dataSource: {
              ...state.dataSource,
              Classificacao: {
                ...state.dataSource.Classificacao,
                [index]: {
                  ...state.dataSource.Classificacao[index],
                  Error: [
                    ...state.dataSource.Classificacao[index].Error,
                    `O período não pode ser inferior a ${rangeString[1]}`,
                  ],
                },
              },
            },
          }));
        } else if (
          rangeDate[0] !== "0001-01-01" &&
          rangeDate[1] === "2100-12-31"
        ) {
          this.setState((state) => ({
            isOk: false,
            dataSource: {
              ...state.dataSource,
              Classificacao: {
                ...state.dataSource.Classificacao,
                [index]: {
                  ...state.dataSource.Classificacao[index],
                  Error: [
                    ...state.dataSource.Classificacao[index].Error,
                    `O período não pode ser posterior a ${moment(
                      data[index - 1].DataInicio
                    ).format("L")}`,
                  ],
                },
              },
            },
          }));
        } else {
          this.setState((state) => ({
            isOk: false,
            dataSource: {
              ...state.dataSource,
              Classificacao: {
                ...state.dataSource.Classificacao,
                [index]: {
                  ...state.dataSource.Classificacao[index],
                  Error: [
                    ...state.dataSource.Classificacao[index].Error,
                    `A data não pode ficar entre ${rangeString[0]} e ${rangeString[1]}`,
                  ],
                },
              },
            },
          }));
        }
      }

      if (this.state.isOk) this.setIntervalDate(data, item, index);
    });
  };

  findMinMax(data) {
    if (data.length) {
      let min = data[0].DataInicio || "0001-01-01",
        max = data[0].DataFim || "2100-12-31";

      for (let i = 0; i < data.length; i++) {
        const tempMin = data[i].DataInicio,
          tempMax = data[i].DataFim;

        if (min) {
          if (!tempMin) {
            min = "0001-01-01";
          } else {
            min = moment(tempMin).isBefore(min) ? tempMin : min;
          }
        }

        if (max) {
          if (!tempMax) {
            max = "2100-12-31";
          } else {
            max = moment(tempMax).isAfter(max) ? tempMax : max;
          }
        }
      }

      this.setState({ rangeDate: [min, max] });

      return [min, max];
    } else {
      return [];
    }
  }

  setIntervalDate(data, item, index) {
    const interval = index
        ? moment
            .duration(moment(item.DataInicio).diff(data[index - 1].DataFim))
            .asDays()
        : 0,
      prevPeriod = data[index - 1],
      currentPeriod = item;
    let changed = false,
      newDate;

    if (interval > 1) {
      if (prevPeriod.Status === 2) {
        data[index - 1].DataFim = moment(currentPeriod.DataInicio)
          .subtract(1, "days")
          .format();
        this.setState((prevState) => ({
          dataSource: {
            ...prevState.dataSource,
            Classificacao: { ...data },
          },
        }));
        changed = true;
      } else if (item.Status === 2 && !changed) {
        data[index].DataInicio = moment(prevPeriod.DataFim)
          .add(1, "days")
          .format();
        this.setState((prevState) => ({
          dataSource: {
            ...prevState.dataSource,
            Classificacao: { ...data },
          },
        }));
      } else {
        newDate = {
          Id: 0,
          Status: 2,
          DataInicio: moment(prevPeriod.DataFim).add(1, "days").format(),
          DataFim: moment(currentPeriod.DataInicio)
            .subtract(1, "days")
            .format(),
        };
        this.handleAdd(shortid.generate(), newDate);
      }
    }
  }

  handleAdd = (key, date) => {
    const { rangeDate } = this.state;
    let newDate = {
      Id: 0,
      Status: 0,
      Error: [],
    };

    if (!date) {
      if (rangeDate[0] && rangeDate[1]) {
        newDate = {
          ...newDate,
          DataInicio: moment(rangeDate[1]).add(1, "days").format(),
          DataFim: null,
        };
      } else {
        newDate = {
          ...newDate,
          DataInicio: rangeDate[1]
            ? moment(rangeDate[1]).add(1, "days").format()
            : null,
          DataFim: rangeDate[0]
            ? moment(rangeDate[0]).subtract(1, "days").format()
            : null,
        };
      }
    }

    this.setState((prevState) => ({
      dataSource: {
        ...prevState.dataSource,
        Classificacao: {
          ...prevState.dataSource.Classificacao,
          [key]: date ? date : newDate,
        },
      },
    }));
  };

  handleDelete = async (key) => {
    const { editClassify, getIcms, filterStr, extraData } = this.props,
      { IdProduto, Classificacao } = this.state.dataSource;
    let newData = { ...Classificacao };

    if (editClassify && Classificacao[key].Id) {
      const ids = {
        IdProduto: IdProduto[0],
        IdNcm: Classificacao[key].Id,
      };
      delete newData[key];
      await this.props.deletePeriodClassify(ids);
      if (!newData.length && editClassify) {
        getIcms(filterStr, extraData);
      }
    } else {
      delete newData[key];
    }

    this.setState((prevState) => ({
      dataSource: {
        ...prevState.dataSource,
        Classificacao: newData,
      },
    }));

    if (!Object.entries(newData).length) this.handleAdd(0);
  };

  handleChange = async (e, key) => {
    const {
      itemFilter,
      filter: { sBaseNcm },
    } = this.props;
    let dataInicio = null;
    let dataFim = null;

    if (sBaseNcm !== "=5" && sBaseNcm !== "=4") {
      const filter = itemFilter + `&Status=${e}`;
      await this.props.getPeriodClassify(filter);
      const { query, statusQuery } = this.props;

      if (statusQuery === 200) {
        dataInicio = query.DataInicio || null;
        dataFim = query.DataFim || null;
      }
    }

    this.setState(
      (prevState) => ({
        dataSource: {
          ...prevState.dataSource,
          Classificacao: {
            ...prevState.dataSource.Classificacao,
            [key]: {
              ...prevState.dataSource.Classificacao[key],
              DataInicio: dataInicio,
              DataFim: dataFim,
              Status: e,
            },
          },
        },
      }),
      () => this.clearError()
    );
  };

  handleChangeDate = (dateStrings, key, name) => {
    this.setState(
      (prevState) => ({
        dataSource: {
          ...prevState.dataSource,
          Classificacao: {
            ...prevState.dataSource.Classificacao,
            [key]: {
              ...prevState.dataSource.Classificacao[key],
              [name]: dateStrings ? dateStrings : null,
            },
          },
        },
      }),
      () => this.clearError()
    );
  };

  clearError = () => {
    const { Classificacao } = this.state.dataSource;

    this.setState((state) => ({
      dataSource: {
        ...state.dataSource,
        Classificacao: {
          ...Object.values(Classificacao).map((item) => {
            return {
              ...item,
              Error: [],
            };
          }),
        },
      },
    }));
  };

  classifyProducts = async () => {
    const { filterStr, selectedAll, extraData } = this.props,
      filter = filterStr !== "" ? "?filter=" + filterStr : null;
    let data = { ...this.state.dataSource };

    data = {
      ...data,
      Classificacao: Object.values(data.Classificacao).map((item) => {
        return {
          ...item,
          DataInicio: item.DataInicio
            ? dateToEnglish(item.DataInicio)
            : "0001-01-01",
          DataFim: item.DataFim ? dateToEnglish(item.DataFim) : null,
          Error: [],
        };
      }),
    };
    data = {
      ...data,
      Classificacao: _.sortBy(data.Classificacao, "DataInicio"),
    };

    await this.validateClassify(data.Classificacao);

    if (this.state.isOk) {
      this.setState((state) => ({
        dataSource: {
          ...state.dataSource,
          Classificacao: Object.values(state.dataSource.Classificacao).map(
            (item) => {
              return {
                ...item,
                DataInicio: item.DataInicio
                  ? dateToEnglish(item.DataInicio)
                  : null,
                DataFim: item.DataFim ? dateToEnglish(item.DataFim) : null,
              };
            }
          ),
        },
      }));

      if (!selectedAll) {
        this.props.classifyProduct(this.state.dataSource, filter, extraData);
      } else {
        this.props.classifyProduct(
          this.state.dataSource,
          filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true",
          extraData
        );
      }
      this.props.handleReset();
      this.props.onClose("visibleDrawerClassify", true);
    }
  };

  disabledDate(current) {
    return current && current > moment().endOf("day");
  }

  considerRevenue = () => {
    const {
        props,
        props: { extraData, filterStr, selectedAll },
      } = this,
      { dataSource } = this.state,
      filter = filterStr !== "" ? "?filter=" + filterStr : null;
    let data = {
      Cnpj: JSON.parse(sessionStorage.getItem("eRecuperadorCompany")).Cnpj,
      IdProduto: dataSource.IdProduto,
    };

    this.setState(
      (prevState) => ({
        isRevenue: !prevState.isRevenue,
      }),
      async () => {
        const { isRevenue } = this.state;
        data = {
          ...data,
          ConsiderarReceita: isRevenue,
        };
        if (!selectedAll) {
          await props.considerRevenue(data, filter);
        } else {
          await props.considerRevenue(
            data,
            filterStr ? `?filter=${filterStr}&todos=true` : "?todos=true"
          );
        }
        props.getIcms(filter, extraData);
        props.getPisCofins();
      }
    );
  };

  renderAlertMessages(errors) {
    if (errors.length) {
      return errors.map((item) => {
        return (
          <span key={shortid.generate()} className="d-block text-danger">
            {item}
          </span>
        );
      });
    }
  }

  render() {
    const { isFetching, onClose, visibleDrawer } = this.props;
    const { dataSource, disabledButton, isRevenue } = this.state;
    const isEdit = dataSource.Classificacao.length;
    const dateFormat = "DD/MM/YYYY";

    return (
      <Drawer
        title="Classificar produtos"
        className="ant-drawer--custom"
        width={720}
        onClose={() => onClose("visibleDrawerClassify", true)}
        closable={isFetching ? false : true}
        maskClosable={isFetching ? false : true}
        visible={visibleDrawer}
      >
        <Form className="ant-form--custom" layout="vertical" hideRequiredMark>
          <Switch
            checkedChildren="Sim"
            unCheckedChildren="Não"
            defaultChecked={isRevenue}
            loading={isFetching ? true : false}
            disabled={isFetching ? true : false}
            onChange={this.considerRevenue}
          />
          <label className="ml-2">Considerar receita?</label>
          <Divider className="mt-3 mb-0" />

          {Object.keys(dataSource.Classificacao).map((item, index) => {
            return (
              <Fragment key={index}>
                <Row gutter={10}>
                  <Col span={9}>
                    <Form.Item label="Classificação *">
                      <Select
                        className="ant-select--custom"
                        defaultValue={0}
                        value={dataSource.Classificacao[item].Status}
                        disabled={!isRevenue}
                        onChange={(e) => this.handleChange(e, index)}
                      >
                        <Option value={0}>Selecione</Option>
                        {classifyOptions.map((option) => {
                          return (
                            <Option key={option.id} value={option.value}>
                              {option.text}
                            </Option>
                          );
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="Data inicial">
                      <DatePicker
                        className="ant-calendar--custom"
                        defaultValue={formatDate(
                          dataSource.Classificacao[item].DataInicio
                        )}
                        value={formatDate(
                          dataSource.Classificacao[item].DataInicio
                        )}
                        format={dateFormat}
                        disabledDate={this.disabledDate}
                        disabled={!isRevenue}
                        onChange={(dates, dateStrings) =>
                          this.handleChangeDate(dateStrings, item, "DataInicio")
                        }
                      />
                    </Form.Item>
                  </Col>
                  <Col span={6}>
                    <Form.Item label="Data final">
                      <DatePicker
                        className="ant-calendar--custom"
                        defaultValue={formatDate(
                          dataSource.Classificacao[item].DataFim
                        )}
                        value={formatDate(
                          dataSource.Classificacao[item].DataFim
                        )}
                        format={dateFormat}
                        disabled={!isRevenue}
                        onChange={(dates, dateStrings) =>
                          this.handleChangeDate(dateStrings, item, "DataFim")
                        }
                      />
                    </Form.Item>
                  </Col>
                  {index + 1 ===
                  Object.entries(dataSource.Classificacao).length ? (
                    <Col span={3} style={{ marginTop: "45px" }}>
                      <Button
                        className="btn mr-2"
                        type="danger"
                        icon="delete"
                        ghost
                        disabled={!isRevenue}
                        onClick={() => this.handleDelete(item)}
                      />

                      <Button
                        className="btn"
                        type="default"
                        icon="plus"
                        disabled={disabledButton || !isRevenue}
                        onClick={() => this.handleAdd(parseInt(item) + 1)}
                      />
                    </Col>
                  ) : index + 1 ===
                    Object.entries(dataSource.Classificacao).length ? (
                    <Col span={2} style={{ marginTop: "45px" }}>
                      <Button
                        className="btn"
                        type="default"
                        icon="plus"
                        disabled={disabledButton || !isRevenue}
                        onClick={() => this.handleAdd(parseInt(item) + 1)}
                      />
                    </Col>
                  ) : (
                    <Col span={2} style={{ marginTop: "45px" }}>
                      <Button
                        className="btn mr-2"
                        type="danger"
                        icon="delete"
                        ghost
                        disabled={!isRevenue}
                        onClick={() => this.handleDelete(item)}
                      />
                    </Col>
                  )}
                </Row>

                {dataSource.Classificacao[item].Error &&
                  this.renderAlertMessages(
                    dataSource.Classificacao[item].Error
                  )}
              </Fragment>
            );
          })}
        </Form>

        <div className="ant-drawer__footer" style={{ width: "720px" }}>
          <Button
            type="primary"
            onClick={this.classifyProducts}
            disabled={disabledButton || !isRevenue}
          >
            {!isEdit ? "Classificar" : "Editar"}
          </Button>
        </div>
      </Drawer>
    );
  }
}

const loadingConsiderRevenue = createLoadingSelector(["CONSIDER_REVENUE_ICMS"]);
const loadingGetPeriodClassify = createLoadingSelector(["GET_PERIOD_CLASSIFY"]);

const mapStateToProps = (state) => ({
  status: state.icms.status,
  products: state.icms.list,
  query: state.icms.query,
  statusQuery: state.icms.statusQuery,
  isFetching: loadingConsiderRevenue(state) || loadingGetPeriodClassify(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getIcms,
      getPisCofins,
      classifyProduct,
      deletePeriodClassify,
      considerRevenue,
      getPeriodClassify,
    },
    dispatch
  );
export default connect(mapStateToProps, mapDispatchToProps)(DrawerClassify);
